module.exports = __webpack_public_path__ + "c9149029049de0e1cfad928c3592d903.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Pachantiew/4.jpg
// module id = 1363
// module chunks = 47